// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { split } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import config from './config'

const httpLink = new HttpLink({
   // You should use an absolute URL here
   uri: process.env.VUE_APP_HASURA_URL_HTTP,
   headers:{
      "x-hasura-admin-secret": process.env.VUE_APP_HASURA_SECRET
   }
});

const wsLink = new WebSocketLink({
   uri: process.env.VUE_APP_HASURA_URL_WS,
   options: {
      reconnect: true,
      connectionParams: () =>{
         return {
            headers:{
               "x-hasura-admin-secret": process.env.VUE_APP_HASURA_SECRET
            }
         }
      }
   },
})

const link = split(
   // split based on operation type
   ({ query }) => {
     const definition = getMainDefinition(query)
     return definition.kind === 'OperationDefinition' &&
       definition.operation === 'subscription'
   },
   wsLink,
   httpLink
);

const apolloClient = new ApolloClient({
   link,
   cache: new InMemoryCache(),
   connectToDevTools: true,
});

Vue.use(VueApollo)

const apolloProvider = new VueApollo({
   defaultClient: apolloClient,
 })
 


import store from './store';
import router from './router';
import Vuetify from 'vuetify';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/css/v4-shims.min.css';
import './theme/default.styl';
import './theme/flaticon.css'
import './theme/animate.css';
import './theme/colors.css';
import 'vue2-animate/dist/vue2-animate.css';
import api from '@consigmais-team/vue-common/services/api.services';
import util from '@consigmais-team/vue-common/util';

api.setBaseUrl(config.serverHost);

import numeral from 'numeral';
import money from 'v-money';

Vue.use(money, {precision: 2})

const moment = require('moment')
require('moment/locale/pt-br')
Vue.use(require('vue-moment'), {
   moment
});

// import VeeValidate from 'vee-validate';
import colors from 'vuetify/es5/util/colors';
import Truncate from 'lodash.truncate';
import VueResize from 'vue-resize'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import VueI18n from 'vue-i18n';

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import Viewer from 'v-viewer'
Vue.use(Viewer);

import VueApexCharts from 'vue-apexcharts';
Vue.component('apexchart', VueApexCharts);

import App from './App';

const appColor = {
   name: '',
   primary: '#34383d',
   secondary: '#566369' ,
   accent: '#ecae00'
};

window.nprogress = NProgress;
window.nprogress.configure({
   minimum: 0.12,
   template: "<div class='bar' role='bar' style='background: #1A8BB5 !important; height: 3px !important;'></div>"
});

Vue.config.productionTip = false;

// Helpers
// Global filters
Vue.filter('truncate', Truncate);

// Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(VueResize);

// Vue.use(VeeValidate, {fieldsBagName: 'formFields'});

Vue.use(Vuetify, {
   theme: {
      primary: appColor.name ? colors[appColor.name].darken1 : appColor.primary,
      secondary: appColor.name ? colors[appColor.name].lighten1 : appColor.secondary,
      accent: appColor.accent || colors.amber.darken2
   },
   options: {
      themeVariations: ['primary', 'secondary', 'accent'],
      extra: {
         mainToolbar: {
            color: 'primary',
         },
         sideToolbar: {},
         sideNav: 'primary',
         mainNav: 'primary lighten-1',
         bodyBg: '',
      }
   }
});

numeral.register('locale', 'br', {
   delimiters: {
      thousands: '.',
      decimal: ','
   },
   abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
   },
   currency: {
      symbol: 'R$ '
   }
});

numeral.locale('br');

Vue.filter("fmtMoney", function (value) {
   return numeral(+value).format('$ 0,0.00')
});

Vue.filter("fmtMoneyInt", function (value) {
   return numeral(+value).format('$ 0,0')
});

Vue.filter("fmtFixed", function (value) {
   return numeral(+value).format('0,0.00')
});

Vue.filter("fmtFixedInt", function (value) {
   return numeral(+value).format('0,0')
});

Vue.filter("fmtPercent", function (value) {
   return numeral(+value).format('0.00%')
});

Vue.filter("fmtPercentP1", function (value) {
   return numeral(+value).format('0.0%')
});

Vue.filter("fmtCPF", function (value) {
   return util.applyMask(value, util.Mask.cpf);
});


Vue.prototype.$notifyUser = (msgObj) => {
   window.getApp.snackbar = {
      show: true,
      type: msgObj.type || 'success',
      message: msgObj.message,
      icon: msgObj.icon,
      position: msgObj.position || 'bottom right'
   };
};

/*COMPONENTS REGISTRATION*/
import Crud from '@consigmais-team/vue-common/layout/crudPage/crud';
import CrudForm from '@consigmais-team/vue-common/layout/crudPage/crudForm';
import ATextField from '@consigmais-team/vue-common/components/ATextField';
import ATextAreaField from '@consigmais-team/vue-common/components/ATextAreaField';
import ANumberField from '@consigmais-team/vue-common/components/ANumberField';
import ADateField from '@consigmais-team/vue-common/components/ADateField';
import AAutocompleteField from '@consigmais-team/vue-common/components/AAutocompleteField';
import ASelectField from '@consigmais-team/vue-common/components/ASelectField';
import AComboboxField from '@consigmais-team/vue-common/components/ACombobox';
import ADataGrid from '@consigmais-team/vue-common/components/ADataGrid';
import ADetailGrid from '@consigmais-team/vue-common/components/ADetailGrid.vue';

Vue.component('Crud', Crud);
Vue.component('CrudForm', CrudForm);
Vue.component('ATextField', ATextField);
Vue.component('ATextAreaField', ATextAreaField);
Vue.component('ANumberField', ANumberField);
Vue.component('ADateField', ADateField);
Vue.component('AAutocompleteField', AAutocompleteField);
Vue.component('ASelectField', ASelectField);
Vue.component('AComboboxField', AComboboxField);
Vue.component('ADataGrid', ADataGrid);
Vue.component('ADetailGrid', ADetailGrid);


import messages from './locale';

const i18n = new VueI18n({
   locale: 'pt', // set default locale
   silentTranslationWarn: true,
   messages
});

window.i18n = i18n;
// console.log(i18n);

// Bootstrap application components
/* eslint-disable no-new */
new Vue({
   el: '#app',
   apolloProvider, //
   i18n,
   store,
   router,
   api,
   util,
   template: '<App/>',
   components: {App}

});


let cloudinaryTexts = {
   "powered_by_cloudinary": "Media Upload",
   "sources.local.title": "Meus Arquivos",
   "sources.local.drop_file": "Arraste arquivo para cá",
   "sources.local.drop_files": "Arraste arquivos para cá",
   "sources.local.drop_or": "OU",
   "sources.local.select_file": "Escolha...",
   "sources.local.select_files": "Selecione...",
   "sources.url.title": "Link da Internet",
   "sources.url.note": "Link público da imagem na Internet:",
   "sources.url.upload": "Carregar",
   "sources.url.error": "Favor digitar um endereço HTTP válido.",
   "sources.camera.title": "Camera",
   "sources.camera.note": "Certifique-se de ter habilitado seu navegador para acessar sua câmera, posicione e clique capturar:",
   "sources.camera.capture": "Capturar",
   "progress.uploading": "Carregando...",
   "progress.upload_cropped": "Carregar",
   "progress.processing": "Processando...",
   "progress.retry_upload": "Tente novamente",
   "progress.use_succeeded": "OK",
   "progress.failed_note": "Algumas imagens não carregaram."
};


window.cloudinaryOptions = {
   docs: {
      upload_preset: 'osefhec6-custfile',
      cloud_name: 'consigmais',
      resource_type: 'image',
      cropping: 'server',
      sources: ['local'],
      context: {
         brandId: null
      },
      text: cloudinaryTexts
   },
   avatars: {
      upload_preset: 'jyrlhwiq-avatar',
      cloud_name: 'consigmais',
      resource_type: 'image',
      cropping: 'server',
      sources: ['local', 'url', 'camera'],
      context: {
         brandId: () => window.getApp.$store.state.company.brandId
      },
      text: cloudinaryTexts
   },
   logos: {
      upload_preset: 'qrizwyd0-logos',
      cloud_name: 'consigmais',
      resource_type: 'image',
      cropping: 'server',
      sources: ['local', 'url'],
      context: {
         brandId: null
      },
      text: cloudinaryTexts
   }
};


/*
text: {
    "powered_by_cloudinary": "Remessas Media Upload",
    "sources.local.title": "Meus Arquivos",
    "sources.local.drop_file": "Arraste arquivo para cá",
    "sources.local.drop_files": "Arraste arquivos para cá",
    "sources.local.drop_or": "OU",
    "sources.local.select_file": "Escolha...",
    "sources.local.select_files": "Selecione...",
    "sources.url.title": "Link da Internet",
    "sources.url.note": "Link público da imagem na Internet:",
    "sources.url.upload": "Carregar",
    "sources.url.error": "Favor digitar um endereço HTTP válido.",
    "sources.camera.title": "Camera",
    "sources.camera.note": "Certifique-se de ter habilitado seu navegador para acessar sua câmera, posicione e clique capturar:",
    "sources.camera.capture": "Capturar",
    "progress.uploading": "Carregando...",
    "progress.upload_cropped": "Carregar",
    "progress.processing": "Processando...",
    "progress.retry_upload": "Tente novamente",
    "progress.use_succeeded": "OK",
    "progress.failed_note": "Algumas imagens não carregaram."
  }
*/

window.Clipboard = (function(window, document, navigator) {
   var textArea,
      copy;

   function isOS() {
      return navigator.userAgent.match(/ipad|iphone/i);
   }

   function createTextArea(text) {
      textArea = document.createElement('textArea');
      textArea.value = text;
      document.body.appendChild(textArea);
   }

   function selectText() {
      var range,
         selection;

      if (isOS()) {
         range = document.createRange();
         range.selectNodeContents(textArea);
         selection = window.getSelection();
         selection.removeAllRanges();
         selection.addRange(range);
         textArea.setSelectionRange(0, 999999);
      } else {
         textArea.select();
      }
   }

   function copyToClipboard() {
      document.execCommand('copy');
      document.body.removeChild(textArea);
   }

   copy = function(text) {
      createTextArea(text);
      selectText();
      copyToClipboard();
   };

   return {
      copy: copy
   };
})(window, document, navigator);




// WEBPACK FOOTER //
// ./src/main.js